import React from 'react';
import { Link } from 'react-router-dom';
import { CameraIcon, ChevronRightIcon } from 'lucide-react';
export function VisitCTA() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2511">
      <div className="max-w-5xl mx-auto px-4 md:px-8 pt-12" data-id="element-2512">
        <div className="flex flex-col sm:flex-row items-center gap-6 p-6 rounded-xl shadow-sm" style={{
        backgroundColor: '#1e3d2f'
      }} data-id="element-2513">
          <div className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0" style={{
          backgroundColor: 'rgba(200,168,75,0.15)'
        }} data-id="element-2514">
            <CameraIcon size={28} style={{
            color: '#c8a84b'
          }} data-id="element-2515" />
          </div>
          <div className="flex-1 text-center sm:text-left" data-id="element-2516">
            <h2 className="text-xl font-bold uppercase mb-1" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-2517">
              Come See It In Person
            </h2>
            <p className="text-sm" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2518">
              Photos can only show so much. Visit the club to experience our
              facilities firsthand.
            </p>
          </div>
          <Link to="/ContactUs.html" className="inline-flex items-center gap-2 py-2.5 px-5 rounded-lg font-semibold text-sm transition-all hover:opacity-90 flex-shrink-0" style={{
          backgroundColor: '#c8a84b',
          color: '#1a1a1a',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-2519">
            Contact Us
            <ChevronRightIcon size={16} data-id="element-2520" />
          </Link>
        </div>
      </div>
    </div>;
}